import React from "react";
import { Col, Row, Select, Input } from "antd";

export const SmartLinksListFilters = ({ filtros, handleInputChange, handleSelectChange }) => {
  return (
    <Row
      className="d-flex justify-content-left"
      style={{ paddingLeft: "40px", marginBottom: "20px" }}
      gutter={[16, 16]}
    >
      <Col xs={24} sm={12} md={6} lg={4}>
        <Input
          placeholder="ID del Link"
          value={filtros.linkId}
          onChange={(e) => handleInputChange(e, "linkId")}
        />
      </Col>
      <Col xs={24} sm={12} md={6} lg={4}>
        <Select
          className="w-100"
          placeholder="Estado"
          value={filtros.status}
          onChange={(value) => handleSelectChange(value, "status")}
          options={[
            { value: "active", label: "Activo" },
            { value: "inactive", label: "Inactivo" },
          ]}
          allowClear
        />
      </Col>
    </Row>
  );
};